import { IResponse, ICustomer } from '@signal/asp-data-commons';
import { SearchCustomersService } from './../../shared/services/search-customers.service';
import { AlertService } from '../../shared/services/alert.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import * as fromActions from './search-customers.actions';
import { mergeMap, switchMap, map, catchError } from 'rxjs/operators';
import { toData } from '../app.adapter';
import * as fromAdapter from '../search-customers/search-customers.adapter';

@Injectable()

export class SearchCustomersEffects {

    
    searchCustomers: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<fromActions.SearchCustomers>(
            fromActions.SearchCustomersActionTypes.SEARCH_CUSTOMERS
        ),
        mergeMap((action: fromActions.SearchCustomers) =>
            this.searchCustomersService.getCustomers(action.payload.firstName,action.payload.lastName,action.payload.query).pipe(
                switchMap((customers: IResponse<ICustomer[]>) => toData(customers)),
                map((customersList: ICustomer[]) => {
                    if(!!action.payload.customerId && customersList.length){
                        return new fromActions.DirectLoadCustomer({customers: fromAdapter.formatPhoneNumber(customersList), customerId:action.payload.customerId});
                    }
                    else{
                        return new fromActions.SearchCustomersSuccess({customers: fromAdapter.formatPhoneNumber(customersList)});
                    }
                }),
                catchError(err => {
                    this.alertService.showAlert('otherTexts.somethingWentWrongPleaseReloadThePage');
                    return of(new fromActions.SearchCustomersFailure({error: err}))
                })
            )
        )
    ))

    constructor(
        private actions$: Actions,
        private searchCustomersService: SearchCustomersService,
        private alertService: AlertService
    ) {

    }
}